module.exports = __webpack_public_path__ + "static/media/logo-sony.5e028249.png";